import {
  Divider,
  Flex,
  Grid,
  GridItem,
  HStack,
  Heading,
  Text,
  VStack,
  useMediaQuery
} from "@chakra-ui/react";

import Email_Icon_Black from "src/resources/icons/Email_Icon_Black.svg";
import { PhoneIcon } from "src/resources/icons";
import { ProfileDto } from "src/types/Profile";
import RightAlignedDrawer from "./rightAlignedModal";
import { RootState } from "src/store/store";
import { useSelector } from "react-redux";
import { useState } from "react";

interface CommunicationDetailsProps {
  userData: ProfileDto | null;
}

export const CommunicationDetails: React.FC<CommunicationDetailsProps> = ({
  userData,
}) => {
  const [isSmallScreen] = useMediaQuery("(max-width: 630px)");
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";
  // Drawer state
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const handleCloseDrawer = () => setIsDrawerOpen(false);

  if (!userData) {
    return <Text>No communication details available</Text>;
  }

  const communication = userData.communicationDetails || {};

  return (
    <Flex direction="column" width="100%">
      {/* Header Row with Edit Button */}
      <Flex
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        mb={4}
      >
        <Heading fontSize="32px">
          {isHindiLabels ? "संचार विवरण" : "Communication Details"}
        </Heading>
      </Flex>

      <Grid
        templateColumns={isSmallScreen ? "1fr" : "repeat(2, 1fr)"}
        gap={isSmallScreen ? 6 : "1rem"}
        pb={isSmallScreen ? 10 : 0}
      >
        {/* Mobile Number */}
        <GridItem>
          <VStack alignItems="flex-start">
            <HStack>
              <PhoneIcon />
              <Heading fontSize="24px">
                {isHindiLabels ? "मोबाइल नंबर" : "Mobile Number"}
              </Heading>
            </HStack>
            <Text>{communication.mobileNumber || "Not Available"}</Text>
          </VStack>
        </GridItem>

        {/* Alternate Mobile */}
        <GridItem>
          <VStack alignItems="flex-start">
            <HStack>
              <PhoneIcon />
              <Heading fontSize="24px">
                {isHindiLabels ? "वैकल्पिक मोबाइल" : "Alternate Mobile"}
              </Heading>
            </HStack>
            <Text>{communication.altMobileNumber || "Not Available"}</Text>
          </VStack>
        </GridItem>

        {/* Divider */}
        <GridItem colSpan={2}>
          <Divider my="1rem" />
        </GridItem>

        {/* Email */}
        <GridItem>
          <VStack alignItems="flex-start">
            <HStack>
              <img src={Email_Icon_Black} alt="email" />
              <Heading fontSize="24px">
                {isHindiLabels ? "ईमेल आईडी" : "Email ID"}
              </Heading>
            </HStack>
            <Text>{userData?.emailId || communication?.email || "Not Available"}</Text>
          </VStack>
        </GridItem>

        {/* Alternate Email */}
        <GridItem>
          <VStack alignItems="flex-start">
            <HStack>
              <img src={Email_Icon_Black} alt="email" />
              <Heading fontSize="24px">
                {isHindiLabels ? "वैकल्पिक ईमेल" : "Alternate Email"}
              </Heading>
            </HStack>
            <Text>{communication.altEmailId || "Not Available"}</Text>
          </VStack>
        </GridItem>
      </Grid>

      {/* Drawer Integration */}
      <RightAlignedDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        view={"COMMUNICATION_DETAILS"} userData={null} onSave={function (): void {
          throw new Error("Function not implemented.");
        } }      />
    </Flex>
  );
};
